module.exports = __webpack_public_path__ + "img/no-image.5d751afc.png";